export const APP_URL = window.location.origin;
export const LOGIN_URL = `${APP_URL}/login`;
export const API_URL_DEFAULT = process.env.API_URL_DEFAULT;
